import { PaperClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiPaper: Record<PaperClassKey, CSSProperties> = {
  root: {},
  elevation0: {},
  elevation1: {
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.08), inset 2px 2px 4px rgba(0, 0, 0, 0.05);',
  },
  elevation2: {},
  elevation3: {},
  elevation4: {},
  elevation5: {},
  elevation6: {},
  elevation7: {},
  elevation8: {},
  elevation9: {},
  elevation10: {},
  elevation11: {},
  elevation12: {},
  elevation13: {},
  elevation14: {},
  elevation15: {},
  elevation16: {},
  elevation17: {},
  elevation18: {},
  elevation19: {},
  elevation20: {},
  elevation21: {},
  elevation22: {},
  elevation23: {},
  elevation24: {},
  outlined: {},
  rounded: { borderRadius: '26px' },
};
